module.exports = __webpack_public_path__ + "static/media/Ganga Ram Building.b6540621.mp3";